import { render, staticRenderFns } from "./ListEditViewItem.vue?vue&type=template&id=3905639f&scoped=true&"
import script from "./ListEditViewItem.vue?vue&type=script&lang=js&"
export * from "./ListEditViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ListEditViewItem.vue?vue&type=style&index=0&id=3905639f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905639f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3905639f', component.options)
    } else {
      api.reload('3905639f', component.options)
    }
    module.hot.accept("./ListEditViewItem.vue?vue&type=template&id=3905639f&scoped=true&", function () {
      api.rerender('3905639f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/ListEditView/ListEditViewItem.vue"
export default component.exports